export function request(userId, uid) {
    return {
        type: 'BETSLIP_REMOVE_BET',
        userId,
        uid
    };
}
